import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function Login() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="eyebrow">Loading system…</p>
      </div>
    );
  }
  if (user) return <Navigate to="/today" replace />;

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/today";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <div className="glass-panel p-10 text-center relative overflow-hidden">
          <div className="absolute top-4 right-4">
            <span className="status-pill text-[10px]" data-testid="system-online-pill">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
              System Online
            </span>
          </div>
          <div className="mt-8 mb-2">
            <h1 className="text-4xl font-extrabold tracking-tight font-heading">
              <span className="text-[#9cc6f0]">Growth</span>
              <span className="text-white">OS</span>
              <span className="text-slate-400 font-semibold text-lg ml-2">PIT</span>
            </h1>
          </div>
          <p className="text-slate-400 text-sm mt-4 mb-8">
            The revenue pipeline engine. Track prospects from application to closed deal.
          </p>
          <button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 px-6 py-3.5 rounded-full bg-[#4690d9] hover:bg-[#5a9fe0] text-white font-semibold transition-all duration-300 hover:shadow-[0_0_24px_rgba(70,144,217,0.45)]"
          >
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
              <path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" opacity=".8" />
              <path fill="#fff" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18A10.97 10.97 0 0 0 1 12c0 1.78.43 3.45 1.18 4.94l3.66-2.84z" opacity=".6" />
              <path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" opacity=".9" />
            </svg>
            Sign in with Google
          </button>
          <p className="text-[11px] text-slate-500 mt-6 font-mono-tech uppercase tracking-wider" data-testid="domain-restriction-note">
            Restricted to GrowthOS Team Members
          </p>
        </div>
      </div>
    </div>
  );
}
